export const APP_SYSTEM_NAMES = {
  platform: '平台管理系统',
  hospital: '医院管理系统',
  pharmacy: '药店管理系统',
  distributor: '渠道管理系统'
} as const;

export type AppSystemKey = keyof typeof APP_SYSTEM_NAMES;
